import React,{Component} from 'react';

export class EDUCATIONALOBJECTIVES extends Component{
    render(){
        return(
            <>
            <p>The Board of Intermediate Education Karachi has modernized education objectives that are following: </p>
            <ol>
                <li>Provide the updated courses curriculum to students via colleges that meet the international education curriculum.</li>
                <li>Provide all the course material to students of all subjects that are according with international standards.</li>
                <li>Examination procedure is, confidential, secured and transparent.</li>
                <li>Senior professors set the papers of examination in confidential and secure way.</li>
                <li>Examination Papers pattern are according to international standards.</li>
                <li>Senior Lecturers conduct the examination on different location of assigned centers by the Board.</li>
                <li>Senior professors assess the paper of students</li>
                <li>Provide the results On time with transparency and adequacy</li>
                <li>Complete statistics is to provide of the appeared, passed and failure students.</li>
                <li>We believe on Computerization and developing the E-infrastructure in the Board.</li>
            </ol>
            </>
        )
    }
}

export class Mission extends Component{
    render(){
        return(
            <>
            <p className="formula">“Knowledge is triumph and it is the key to success“</p>
            <p>Conduct the transparent, secured examination of students with secured and confidential assessment to announce results on time on merit basis.</p>
            </>
        )
    }
}

export class FacultyWiseCourses extends Component{
    render(){
        return(
            <>
            <h3>No Content To Show..</h3>
            </>
        )
    }
}

export class ContactInfo extends Component{
    render(){
        return(
            <>
            <h4>Exchange Numbers</h4>
             <ul>
                 <li>9221 - 99260211</li>
                 <li>9221 - 99260212</li>
                 <li>9221 - 99260213</li>
             </ul>
             <p>Controller of Examination</p>
             <p>Ph: 9221-99260205</p>
             <br/>
             <p>Deputy Controller of Examination</p>
             <p>Ph: 9221-9260207</p>
             <br/>
             <p>Extention: 2026 for Examination Affairs</p>
            </>
        )
    }
}